import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import type { AppModule, Permission, Role } from './access.models';
import { AccessService } from './access.service';

export function requirePermission(...permissions: readonly Permission[]): CanActivateFn {
  return () => {
    const access = inject(AccessService);
    const router = inject(Router);

    return access.satisfies({ permissions }) ? true : router.createUrlTree(['/']);
  };
}

export function denyRoles(roles: readonly Role[]): CanActivateFn {
  return () => {
    const access = inject(AccessService);
    const router = inject(Router);

    return roles.some((role) => access.hasRole(role)) ? router.createUrlTree(['/']) : true;
  };
}

/**
 * Lets the route open only when the workspace has one of `apps` switched on in
 * the app market. The backend refuses the module's endpoints as well; this
 * keeps a bookmarked URL from opening an empty page.
 */
export function requireApp(...apps: readonly AppModule[]): CanActivateFn {
  return () => {
    const access = inject(AccessService);
    const router = inject(Router);

    return access.satisfies({ anyApps: apps }) ? true : router.createUrlTree(['/']);
  };
}
